import { render, staticRenderFns } from "./buildList.vue?vue&type=template&id=779c363e&scoped=true"
import script from "./buildList.vue?vue&type=script&lang=js"
export * from "./buildList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779c363e",
  null
  
)

export default component.exports